import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Heart } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-white/40 relative" data-id="element-261">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-262">
        <FadeIn data-id="element-263">
          <div className="flex justify-center mb-8" data-id="element-264">
            <div className="w-16 h-16 bg-cream rounded-full flex items-center justify-center shadow-sm" data-id="element-265">
              <Heart className="text-accent w-8 h-8" data-id="element-266" />
            </div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-brown-dark mb-8" data-id="element-267">
            Sabemos lo difícil que es...
          </h2>
          <p className="text-xl text-brown-dark/80 leading-relaxed font-serif italic" data-id="element-268">
            "Has probado dejarlo llorar, pero no pudiste soportarlo. Intentaste
            seguir rutinas rígidas, pero cada noche se siente diferente. Los
            consejos genéricos no tomaron en cuenta tu cansancio extremo. Y
            ahora, te encuentras al borde del agotamiento, sin saber qué más
            hacer."
          </p>
        </FadeIn>
      </div>
    </section>;
}